/* eslint no-nested-ternary: 0 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { Select, Button } from '@surfline/quiver-react';
import en from '../../../international/translations/en';

export default class EditSettingsForm extends Component {
  static propTypes = {
    userSettings: PropTypes.object.isRequired,
    onSettingChange: PropTypes.func.isRequired,
    editSettingsErrorMessage: PropTypes.string,
    editSettingsSuccessMessage: PropTypes.string,
    redirectUrl: PropTypes.string,
  };

  render() {
    const {
      userSettings,
      onSettingChange,
      editSettingsErrorMessage,
      editSettingsSuccessMessage,
      redirectUrl,
    } = this.props;

    // setup internationalized text
    const {
      label_windSpeed, label_surfHeight, label_tideHeight, label_temperature /* eslint camelcase: 0 */
    } = en.edit_settings.form;

    let messageAlertStyle;
    if (editSettingsSuccessMessage || editSettingsErrorMessage) {
      messageAlertStyle = editSettingsSuccessMessage
      ?
      'editSettingsForm__success__alert'
      :
      'editSettingsForm__error__alert';
    }

    const onChange = (fieldName) => (selectEvent) => onSettingChange(fieldName, selectEvent.target.value);

    const errorMessage = editSettingsErrorMessage ? 'An error occurred.  Please try again later.' : '';

    // Do not expose actual error message for potential security issues.
    return (
      <div className="editSettingsForm">
        <div className={messageAlertStyle}>
          {editSettingsSuccessMessage ? editSettingsSuccessMessage : errorMessage}
        </div>
        <Select
          id="windSpeed"
          label={label_windSpeed}
          defaultValue="KT"
          select={{ onChange: onChange('windSpeed'), value: userSettings.units.windSpeed }}
          options={[
            { text: 'Knots', value: 'KTS' },
            { text: 'Miles per hour', value: 'MPH' },
            { text: 'Kilometers per hour', value: 'KPH' }
          ]}
        />
        <Select
          id="surfHeight"
          label={label_surfHeight}
          defaultValue="FT"
          select={{ onChange: onChange('surfHeight'), value: userSettings.units.surfHeight }}
          options={[
            { text: 'Feet', value: 'FT' },
            { text: 'Meters', value: 'M' }
          ]}
        />
        <Select
          id="tideHeight"
          label={label_tideHeight}
          defaultValue="FT"
          select={{ onChange: onChange('tideHeight'), value: userSettings.units.tideHeight }}
          options={[
            { text: 'Feet', value: 'FT' },
            { text: 'Meters', value: 'M' }
          ]}
        />
        <Select
          id="temperature"
          label={label_temperature}
          defaultValue="F"
          select={{ onChange: onChange('temperature'), value: userSettings.units.temperature }}
          options={[
            { text: 'Celsius', value: 'C' },
            { text: 'Farenheit', value: 'F' }
          ]}
        />
        {redirectUrl ?
          <Button onClick={() => { window.location.href = redirectUrl; }}>
            Go Back
          </Button>
          : null
        }
      </div>
    );
  }
}
